import { motion } from "framer-motion";
import { Search, PenTool, Layers, BarChart3 } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

const steps = [
  {
    number: "01",
    icon: Search,
    title: "Diagnóstico Estratégico",
    description: "Analisamos seu negócio, mercado e concorrência para criar um plano personalizado.",
  },
  {
    number: "02",
    icon: PenTool,
    title: "Criação de Campanhas",
    description: "Desenvolvemos anúncios e copies persuasivas que convertem visitantes em clientes.",
  },
  {
    number: "03",
    icon: Layers,
    title: "Estrutura de Funil",
    description: "Construímos páginas de conversão e funis otimizados para capturar leads.",
  },
  {
    number: "04",
    icon: BarChart3,
    title: "Gestão e Otimização",
    description: "Monitoramento contínuo e ajustes baseados em dados para maximizar resultados.",
  },
];

export const HowItWorksSection = () => {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 lg:mb-20"
        >
          <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#2563EB] mb-4 block">
            Metodologia
          </span>
          <h2 className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
            Como Funciona
          </h2>
          <p className="text-[#A1A1AA] text-lg max-w-2xl mx-auto">
            Um processo estruturado para transformar seu investimento em marketing em
            resultados reais.
          </p>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              {...fadeInUp}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`step-${index + 1}`}
              className="glass-card bento-card rounded-2xl p-8 relative group"
            >
              {/* Step Number */}
              <span className="step-number absolute top-4 right-4 select-none">
                {step.number}
              </span>

              {/* Icon */}
              <div className="w-14 h-14 rounded-xl icon-container flex items-center justify-center mb-6 group-hover:bg-[#2563EB]/20 transition-colors duration-300">
                <step.icon className="w-7 h-7 text-[#2563EB]" />
              </div>

              {/* Content */}
              <h3 className="font-outfit font-semibold text-xl text-white mb-3">
                {step.title}
              </h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
